import { getElement } from "../shared/pageComponents";
const { computePosition, offset, flip, shift } = window.FloatingUIDOM || await import('@floating-ui/dom');

const headerNavbarWrap = getElement('headerNavbarWrap');

function updateHeaderClasses() {
    if (window.scrollY > 0) {
        headerNavbarWrap.classList.add('shadow-sm', 'bg-white');
    } else {
        headerNavbarWrap.classList.remove('shadow-sm', 'bg-white');
    }
}

if (headerNavbarWrap) {
    window.addEventListener('scroll', updateHeaderClasses);
    updateHeaderClasses();
}

const groupPlansLink = document.querySelector("#planBensHeader a");
const groupPlansDropdownMenu = document.getElementById("solutionsDropdownMenu");

let hoverTimeout;
if (groupPlansLink && groupPlansDropdownMenu) {
    async function showMenu() {
        clearTimeout(hoverTimeout);

        // Compute menu position
        const { x, y } = await computePosition(groupPlansLink, groupPlansDropdownMenu, {
            placement: "bottom-start",
            middleware: [offset(8), flip(), shift()],
        });

        // Apply position
        groupPlansDropdownMenu.style.left = `${x}px`;

        // Show menu
        groupPlansDropdownMenu.classList.add("open", "position-fixed");
        groupPlansLink.classList.add("show-dropdown");
        groupPlansLink.setAttribute("aria-expanded", "true");
    }

    function hideMenu() {
        hoverTimeout = setTimeout(() => {
            groupPlansDropdownMenu.classList.remove("open");
            groupPlansLink.classList.remove("show-dropdown");
            groupPlansLink.setAttribute("aria-expanded", "false");
        }, 200); // Small delay to allow movement between groupPlansLink and groupPlansDropdownMenu
    }

    groupPlansLink.addEventListener("click", (event) => event.preventDefault());

    groupPlansLink.addEventListener("mouseenter", showMenu);
    groupPlansDropdownMenu.addEventListener("mouseenter", showMenu);

    groupPlansLink.addEventListener("mouseleave", hideMenu);
    groupPlansDropdownMenu.addEventListener("mouseleave", hideMenu);
}